import { callDeleteSchedule } from "api/worker/schedule";
import { useModal } from "hooks/useModal";
import { robotKey } from "hooks/worker/keys";
import { notify } from "lib/notify";
import { useState } from "react";
import { useQueryClient } from "react-query";
import { CleaningRobotItem } from "types/response/robot";
import { ScheduleItem } from "types/response/schedule";
import { handleError } from "utils/error/handleError";

type UseDeleteModalProps = {
  afterCallback?: () => void;
  robotId?: string;
};

export const useDeleteModal = ({
  afterCallback,
  robotId,
}: UseDeleteModalProps) => {
  const modal = useModal();
  const [mapName, setMapName] = useState("");
  const [selectedSchedule, setSelectedSchedule] = useState<
    ScheduleItem | undefined
  >(undefined);
  const [isDeleting, setIsDeleting] = useState(false);
  const queryCleint = useQueryClient();

  const onDelete = async () => {
    try {
      setIsDeleting(true);

      if (!robotId) {
        notify("ロボットが選択されていません", "error");
        return;
      }

      const targetScheduleId = selectedSchedule?.scheduleId;

      if (!targetScheduleId) {
        notify("スケジュールが選択されていません", "error");
        return;
      }

      await callDeleteSchedule({
        scheduleId: targetScheduleId,
        robotId,
      });

      queryCleint.setQueryData<CleaningRobotItem[] | undefined>(
        robotKey.list(),
        (prev) => {
          if (!prev) return prev;
          return prev.map((robot) => {
            if (robot.robotId !== robotId) return robot;
            robot.schedules = robot.schedules.filter(
              (s) => s.scheduleId !== targetScheduleId
            );
            return robot;
          });
        }
      );

      modal.onClose();

      if (afterCallback) afterCallback();
    } catch(err) {
      handleError(err)
    } finally {
      setIsDeleting(false);
    }
  };

  const onOpen = (schedule: ScheduleItem, mapName: string) => {
    setSelectedSchedule(schedule);
    setMapName(mapName);
    modal.onOpen();
  };

  const onClose = () => {
    setSelectedSchedule(undefined);
    modal.onClose();
  };

  return {
    ...modal,
    mapName,
    onOpen,
    onClose,
    selectedSchedule,
    onDelete,
    isDeleting,
  };
};
